const en = {
  translation: {
    home: 'Home',
    champions: 'Champions',
    regions: 'Regions',
    agents: 'Agents',
    maps: 'Maps',
    arsenal: 'Arsenal',
    gameList: 'Game List',
    downloadClient: 'DOWNLOAD GAME CLIENT',
    downloadMobile: 'DOWNLOAD RIOT MOBILE COMPANION APP',
    copyrightRiot:
      '™ & © 2022 Riot Games, Inc. League of Legends, Valorant, and all related logos, characters, names and distinctive likenesses thereof are exclusive property of Riot Games, Inc. All Rights Reserved.',
    socialMediaAccounts: 'Social Media Accounts',
    developedByWho: '© 2022 | This website was developed by <a><span>{{word}}</span></a>.',
    featuredChamps: 'FEATURED CHAMPIONS',
    featuredRegions: 'FEATURED REGIONS',
    viewChamps: 'VIEW ALL CHAMPIONS',
    viewRegions: 'VIEV ALL REGIONS',
    viewItems: 'VIEW ALL ITEMS',
    viewRanks: 'VIEW ALL RANKS',
    searchChampion: 'FIND A CHAMPION',
    searchAgent: 'FIND AN AGENT',
    notFoundChampions: 'NO CHAMPIONS FOUND',
    notFoundAgents: 'NO AGENTS FOUND',
    notFoundRegions: 'NO REGIONS FOUND',
    all: 'All',
    sorting: 'SORTING BY',
    'a-z': 'A-Z',
    'z-a': 'Z-A',
    newest: 'NEWEST',
    more: 'MORE',
    valoTextOne: 'WE ARE',
    valoTextTwo: 'DEFY THE LIMITS',
    valoTextThree:
      "Blend your style and experience on a global, competitive stage. You have 13 rounds to attack and defend your side using sharp gunplay and tactical abilities. And, with one life per-round, you'll need to think faster than your opponent if you want to survive. Take on foes across Competitive and Unranked modes as well as Deathmatch and Spike Rush.",
    filterAgent: 'Filter Agent',
    agentsRole: "Agent's Role",
    initiator: 'Initiator',
    duelist: 'Duelist',
    sentinel: 'Sentinel',
    controller: 'Controller',
    seeMore: 'SEE MORE',
    viewGallery: 'VIEW GALLERY',
    chooseYourWeapon: 'CHOOSE YOUR WEAPON',
    valoProtocol: 'VLRT PR0T0C0L',
    allWeapons: 'All Weapons',
    melee: 'Melee',
    tacticalKnife: 'TACTICAL KNIFE',
    standardKnife: 'Standard Knife',
    free: 'Free',
    credit: 'Credit',
    downloadGameText: 'DOWNLOAD  GAME CLIENT',
    downloadAppText: 'DOWNLOAD RIOT MOBILE COMPANION APP',
    lolGameDownload: 'https://signup.leagueoflegends.com/en-us/signup/index',
    valoGameDownload: 'https://playvalorant.com/en-us/download/',
    riotAppDownload: 'https://apps.apple.com/us/app/league-of-legends-friends/id1077150310?ls=1',
    pageRiotHome: 'Home - Riot Games',
    pageLolHome: 'Home - League of Legends',
    pageLolChampions: 'Champions - League of Legends',
    pageLolChampion: '{{word}} - Champion - League of Legends',
    pageLolRegions: 'Regions - League of Legends',
    pageLolItems: 'Items - League of Legends',
    pageLolRanks: 'Ranks - League of Legends',
    pageValoHome: 'Home - Valorant',
    pageValoAgents: 'Agents - Valorant',
    pageValoMaps: 'Maps - Valorant',
    pageValoArsenal: 'Arsenal - Valorant',
    pageValoRanks: 'Ranks - Valorant',
    valoPearlDescription:
      'Attackers push down into the Defenders on this two-site map set in a vibrant, underwater city. Pearl is a geo-driven map with no mechanics. Take the fight through a compact mid or the longer range wings in our first map set in Omega Earth.',
    valoFractionDescription:
      'A top secret research facility split apart by a failed radianite experiment. With defender options as divided as the map, the choice is yours: meet the attackers on their own turf or batten down the hatches to weather the assault.',
    valoBreezeDescription:
      "Take in the sights of historic ruins or seaside caves on this tropical paradise. But bring some cover. You'll need them for the wide open spaces and long range engagements. Watch your flanks and this will be a Breeze.",
    valoIceboxDescription:
      'Your next battleground is a secret Kingdom excavation site overtaken by the arctic. The two plant sites protected by snow and metal require some horizontal finesse. Take advantage of the ziplines and they’ll never see you coming.',
    valoBindDescription:
      'Two sites. No middle. Gotta pick left or right. What’s it going to be then? Both offer direct paths for attackers and a pair of one-way teleporters make it easier to flank.',
    valoHavenDescription:
      'Beneath a forgotten monastery, a clamour emerges from rival Agents clashing to control three sites. There’s more territory to control, but defenders can use the extra real estate for aggressive pushes.',
    valoSplitDescription:
      'If you want to go far, you’ll have to go up. A pair of sites split by an elevated center allows for rapid movement using two rope ascenders. Each site is built with a looming tower vital for control. Remember to watch above before it all blows sky-high.',
    valoAscentDescription:
      'An open playground for small wars of position and attrition divide two sites on Ascent. Each site can be fortified by irreversible bomb doors; once they’re down, you’ll have to destroy them or find another way. Yield as little territory as possible.',
    role: 'Role',
    skins: 'Skins',
    abilities: 'Abilities',
    detail: 'Detail',
    passive: 'Passive',
    volarantProtocol: 'VLRT PR0T0C0L',
    head: 'Head',
    body: 'Body',
    leg: 'Leg',
    range: 'Range',
    magazineSize: 'Magazine Size',
    notFound: 'LOST? TAKE A MAGICAL JOURNEY BACK TO THE KNOWN UNIVERSE.',
    returnToUniverse: 'RETURN TO UNIVERSE',
    legalJibberJabberLink: 'https://www.riotgames.com/en/legal',
    legalJibberJabberText: `<link1><span>riotgamesallinone.com</span></link1> was created under Riot Games' <link2><span>"Legal Jibber Jabber"</span></link2> policy using assets owned by Riot Games. Riot Games does not endorse or sponsor this project.`,
    devSocialMediaAccounts: "Developer's Social Media Accounts",
  },
};

export default en;
